import { ReportsState, ReportCategory, Report, ReportParam } from './store'
import {RequestState } from '../../types'

export const LOAD_REPORTS_REQUEST = 'LOAD_REPORTS_REQUEST'
export const LOAD_REPORTS_RECEIVED = 'LOAD_REPORTS_RECEIVED'
export const LOAD_REPORTS_ERROR = 'LOAD_REPORTS_ERROR'
export const LOAD_REPORT_DETAILS_REQUEST = 'LOAD_REPORT_DETAILS_REQUEST'
export const LOAD_REPORT_DETAILS_RECEIVED = 'LOAD_REPORT_DETAILS_RECEIVED'
export const LOAD_REPORT_DETAILS_ERROR = 'LOAD_REPORT_DETAILS_ERROR'
export const LOAD_REPORT_HTML_REQUEST = 'LOAD_REPORT_HTML_REQUEST'
export const LOAD_REPORT_HTML_RECEIVED = 'LOAD_REPORT_HTML_RECEIVED'
export const LOAD_REPORT_HTML_ERROR = 'LOAD_REPORT_HTML_ERROR'
export const SET_REPORT_PARAMS = 'SET_REPORT_PARAMS'

export type ReportsAction =
  | { type: typeof LOAD_REPORTS_REQUEST }
  | { type: typeof LOAD_REPORTS_RECEIVED; reports: ReportCategory[] }
  | { type: typeof LOAD_REPORTS_ERROR }
  | { type: typeof LOAD_REPORT_DETAILS_REQUEST }
  | { type: typeof LOAD_REPORT_DETAILS_RECEIVED; report: Report }
  | { type: typeof LOAD_REPORT_DETAILS_ERROR }
  | { type: typeof LOAD_REPORT_HTML_REQUEST }
  | { type: typeof LOAD_REPORT_HTML_RECEIVED; report: string }
  | { type: typeof LOAD_REPORT_HTML_ERROR }
  | { type: typeof SET_REPORT_PARAMS; params: ReportParam[] }

export function reportsReducer(state: ReportsState, action: ReportsAction) {
  switch (action.type) {
    case LOAD_REPORTS_REQUEST: {
      return {
        ...state,
        reports: {
          ...state.reports,
          reports: [],
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_REPORTS_RECEIVED: {
      return {
        ...state,
        reports: {
          ...state.reports,
          reports: action.reports,
          requestState: RequestState.Loaded
        }
      }
    }

    case LOAD_REPORTS_ERROR: {
      return {
        ...state,
        reports: {
          ...state.reports,
          reports: [],
          requestState: RequestState.Error
        }
      }
    }

    case LOAD_REPORT_DETAILS_REQUEST: {
      return {
        ...state,
        currentReport: {
          report: undefined,
          requestState: RequestState.Loading
        },
        reportHtml: {
          report: undefined,
          requestState: RequestState.NotLoaded
        }
      }
    }

    case LOAD_REPORT_DETAILS_RECEIVED: {
      return {
        ...state,
        currentReport: {
          report: action.report,
          requestState: RequestState.Loaded
        }
      }
    }

    case LOAD_REPORT_DETAILS_ERROR: {
      return {
        ...state,
        currentReport: {
          report: undefined,
          requestState: RequestState.Error
        }
      }
    }

    case SET_REPORT_PARAMS: {
      if (state.currentReport.report) {
        return {
          ...state,
          reportHtml: {
            report: undefined,
            requestState: RequestState.NotLoaded
          },
          currentReport: {
            ...state.currentReport,

            report: {
              ...state.currentReport.report,
              params: action.params
            }
          }
        }
      }
      throw new Error("Cannot set param when report undefined")
    }

    case LOAD_REPORT_HTML_REQUEST: {
      return {
        ...state,
        reportHtml: {
          report: undefined,
          requestState: RequestState.Loading
        }
      }
    }

    case LOAD_REPORT_HTML_RECEIVED: {
      return {
        ...state,
        reportHtml: {
          report: action.report,
          requestState: RequestState.Loaded
        }
      }
    }

    case LOAD_REPORT_HTML_ERROR: {
      return {
        ...state,
        reportHtml: {
          report: undefined,
          requestState: RequestState.Error
        }
      }
    }

    default: {
      return state
    }
  }
}
